import rawCountries from "src/views/Overview/rawCountries";

export const countryMap = rawCountries.map(c => ({
  name: c[0],
  region: c[1],
  code: c[2].toUpperCase(), // AL
  dialCode: c[3],           // 355
}));

export const getCountryByCode = (code) =>
  countryMap.find(x => x.code === code?.toUpperCase());

export const getDialCodeByCountry = (code) =>
  getCountryByCode(code)?.dialCode || "";
